export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-ax-dark">
      <div className="relative z-10">
        <h1 className="text-8xl md:text-[10rem] font-black text-white/5 select-none pointer-events-none absolute -top-20 left-1/2 -translate-x-1/2">
          404
        </h1>
        <div className="relative">
          <div className="w-16 h-16 bg-ax-red/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-error-warning-line text-ax-red text-2xl" />
          </div>
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-white mb-4">
            页面未找到
          </h2>
          <p className="text-ax-silver-dark mb-8">
            您访问的页面不存在，请返回首页继续浏览
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 bg-ax-red text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-ax-red-dark transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" />
            返回首页
          </a>
        </div>
      </div>
    </div>
  );
}